import {
    customColumnProps,
    DynamicTable,
} from "@maherunlocker/custom-react-table";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSnapshot } from "valtio";
import { ToastContainer } from "react-toastify";
import { useLocation } from "react-router-dom";
import {
    store,
    setIsEdited,
    setModify,
    setIsActionsClicked,
    setActions,
    setValidationAction,
} from "./store";
import { store as storeParent, setIsAddCity } from "../../store";
import CustomIcons from "./CustomIcons";
import CustomSideFilter from "./CustomSideFilter";
import CityForm from "./CityForm";
import { getPathAuthorization } from "@components/VerticalLayout";
import { ConfirmationInitializationMessage } from "@components/Common/ConfirmationInitializationMessage";
import { ConfirmationUpdatingDataMessageModal } from "@components/Common/ConfirmationUpdatingDataMessageModal";
import { useCallbackPrompt } from "@hooks/useCallbackPrompt";
import { useSelector } from "react-redux";
import { useAuthHeader } from "../../../../../../api/headersKeycloak";
import { store as storeGlobal } from "@components/VerticalLayout/store";
import { EmptyColumn } from "../shared";

export default function City({ selectedRowShops }: any) {
    const getAuthHeader = useAuthHeader();
    const { isAddCity } = useSnapshot(storeParent);
    const { franchiseID } = useSnapshot(storeGlobal);

    const {
        isActionsClicked,
        isEdited,
        actions,
        validationAction,
    } = useSnapshot(store);
    const [showPrompt, confirmNavigation, cancelNavigation] = useCallbackPrompt(
        isEdited
    );
    const i18nextLng = localStorage.getItem("i18nextLng") || "fr";
    const { t } = useTranslation();
    const location = useLocation();
    const [
        isInInitializationModalOpened,
        setIsInInitializationModalOpened,
    ] = React.useState<boolean>(false);
    const [
        isAddNewDeviseButtonClicked,
        setIsAddNewDeviseButtonClicked,
    ] = React.useState(false);
    const [cityData, setCityData] = React.useState<any>([]);
    const [filterActive, setLocalFilterActive] = React.useState<boolean>(false);
    const [selectedRows, setSelectedRows] = React.useState<any>({});
    const [dataIsUpdated, setDataIsUpdated] = React.useState<boolean | number>(
        false
    );

    const authorizationList = useSelector(
        (state: any) => state.global.infoUser.profileAuthorization
    );

    setModify(
        getPathAuthorization(location.pathname, authorizationList).Modifie
    );

    const urlApi = `${
        process.env.REACT_APP_API_V2_URL
    }/settings/list/city/c&c?franchiseID=${encodeURIComponent(
        franchiseID
    )}&shopId=${encodeURIComponent(selectedRowShops[0].id_boutique_order)}`;

    let arrayOfCustomColumns: customColumnProps[] = [
        {
            indexOFColumn: 999,
            columnName: t("Actions"),
            customJsx: (e: any) => (
                <CustomIcons
                    e={e}
                    setSelectedRows={setSelectedRows}
                    setIsAddCity={setIsAddCity}
                    isAddCity={isAddCity}
                    selectedRowShops={selectedRowShops}
                    setDataIsUpdated={setDataIsUpdated}
                    cityData={cityData}
                />
            ),
            disableFilter: false,
        },
        {
            indexOFColumn: 3,
            columnName: t("Tva"),
            customJsx: (e: any) => {
                return (
                    <span className="preview-text">
                        {e.selectedRow[t("Tva")]}
                    </span>
                );
            },
        },
    ];

    React.useEffect(() => {
        setActions(confirmNavigation);
        setIsActionsClicked(showPrompt as boolean);
        setValidationAction(cancelNavigation);
    }, [showPrompt, confirmNavigation, cancelNavigation]);

    React.useEffect(() => {
        if (i18nextLng === "fr" || i18nextLng === "en") {
            setDataIsUpdated(true);
        }
    }, [i18nextLng]);

    return (
        <React.Fragment>
            <ToastContainer limit={1} />
            <div
                style={{
                    display: "grid",
                    minHeight: "calc(95vh - 350px)",
                    gridTemplateColumns: isAddCity ? "2fr 1fr " : "auto",
                    gridColumnGap: "4px",
                    border: 0,
                }}
            >
                <DynamicTable
                    url={urlApi}
                    showFilter
                    canSelect={true}
                    setData={setCityData}
                    setLocalFilterActive={setLocalFilterActive}
                    filterActive={filterActive}
                    actionColumn={EmptyColumn}
                    arrayOfCustomColumns={arrayOfCustomColumns}
                    requestHeader={{
                        "Accept-Language": i18nextLng,
                        ...getAuthHeader,
                    }}
                    customJsxSideFilterButton={
                        <CustomSideFilter
                            setIsAddCity={setIsAddCity}
                            isAddCity={isAddCity}
                            setLocalFilterActive={setLocalFilterActive}
                            setSelectedRows={setSelectedRows}
                            setIsInInitializationModalOpened={
                                setIsInInitializationModalOpened
                            }
                            isEdited={isEdited}
                            selectedRows={selectedRows}
                        />
                    }
                    showGlobalFilter
                    canExpand={false}
                    elevationTable={1}
                    minHeight={"calc(95vh - 470px)"}
                    maxHeight={"calc(95vh - 460px)"}
                    setDataIsUpdated={setDataIsUpdated}
                    dataIsUpdated={dataIsUpdated}
                    setSelectedRows={setSelectedRows}
                    name="Choice"
                />
                {isAddCity && (
                    <CityForm
                        isAddCity={isAddCity}
                        setIsAddCity={setIsAddCity!}
                        setDataIsUpdated={setDataIsUpdated}
                        setLocalFilterActive={setLocalFilterActive}
                        isAddNewDeviseButtonClicked={
                            isAddNewDeviseButtonClicked
                        }
                        selectedRows={selectedRows}
                        setSelectedRows={setSelectedRows}
                        selectedRowShops={selectedRowShops}
                        cityData={cityData}
                    />
                )}
                {isActionsClicked === true && (
                    <ConfirmationUpdatingDataMessageModal
                        isModalOpened={isActionsClicked}
                        setIsModalOpened={setIsActionsClicked}
                        validationAction={validationAction}
                        actions={actions}
                        setIsEdited={setIsEdited}
                    />
                )}
                {isInInitializationModalOpened === true && (
                    <ConfirmationInitializationMessage
                        isModalOpened={isInInitializationModalOpened}
                        setIsModalOpened={setIsInInitializationModalOpened}
                        setIsClicked={setIsAddNewDeviseButtonClicked}
                        isClicked={isAddNewDeviseButtonClicked}
                        setIsEdited={setIsEdited}
                    />
                )}
            </div>
        </React.Fragment>
    );
}
